"use client";
import {Dropdown} from "flowbite-react";
import {useState} from "react";
import {AngleDown} from "flowbite-react-icons/outline";

export function DropDownMenu({options, onSelect, label, disabled = false}) {
    const [dropdownLabel, setDropdownLabel] = useState(label);

    const onDropdownChange = (newLabel, value) => {
        setDropdownLabel(newLabel);
        onSelect(value);
    }

    if (disabled)
        return (
            <Dropdown
                label={""}
                dismissOnClick={true}
                renderTrigger={() => <div
                    className={"pointer-events-none sl-flex flex-row sl-gap-2 sl-border-radius-8 sl-bg-white sl-border-gray-300 sl-border-1 sl-border-solid sl-shadow-xs sl-pr-16 sl-pl-16 sl-pt-10 sl-pb-10 "}>
                      <span className={"sl-text-gray-700 sl-font-medium sl-text-sm"}>
                          {dropdownLabel}
                      </span>

                </div>}
            />
        );

    return (
        <Dropdown
            label={""}
            dismissOnClick={false}
            renderTrigger={() => <div
                className={"sl-flex flex-row sl-gap-2 sl-border-radius-8 sl-bg-white sl-border-gray-300 sl-border-1 sl-border-solid sl-shadow-xs sl-pr-16 sl-pl-16 sl-pt-10 sl-pb-10 sl-cursor-pointer "}>
                      <span className={"sl-text-gray-700 sl-font-medium sl-text-sm"}>
                          {dropdownLabel}
                      </span>
                <AngleDown size={20} color={"#344054"}/>
            </div>}
        >
            {options?.map((option, index) => {
                return <Dropdown.Item key={index}
                                      onClick={() => onDropdownChange(option.label, option.value)}>{option.label}</Dropdown.Item>
            })
            }
        </Dropdown>
    );
}